export default __webpack_public_path__ + "alberta-invalid-section.3fdec8e79c1e81748c74.svg";